<div class="crud-rows-panel">
  <form [formGroup]="form">
    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Select a Business Unit from the list"
          [matTooltipDisabled]="disabledTooltip(this.businessUnit)">
          <mat-label i18n="@@type.AmmunitionStockEvent.businessUnit">Business Unit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnit" (ngModelChange)="businessUnitChanging($event)"
            [(ngModel)]="businessUnitFilter" (ngModelChange)="businessUnitChanged($event)" #businessUnit
            placeholder="Business Unit" [compareWith]="businessUnitCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnit?.buId}} - {{businessUnit?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Cost Centre from the list"
          [matTooltipDisabled]="disabledTooltip(this.costCentre)">
          <mat-label i18n="@@type.AmmunitionStockEvent.costCentre">Cost Centre</mat-label>
          <mat-select formControlName="costCentre" id="costCentre" (ngModelChange)="costCentreChanging($event)"
            [(ngModel)]="costCentreFilter" (ngModelChange)="costCentreChanged($event)" #costCentre
            placeholder="Cost Centre" [compareWith]="costCentreCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let costCentre of costCentreSelectionList" [value]="costCentre">
              {{costCentre?.ccId}} - {{costCentre?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span *ngIf="requiresRanger()">
        <mat-form-field matTooltip="Select a Ranger from the list" class="crud-item-input-wide"
          [matTooltipDisabled]="disabledTooltip(this.ranger)">
          <mat-label i18n="@@type.AmmunitionStockEvent.ranger">Ranger</mat-label>
          <input matInput formControlName="ranger" id="ranger" (ngModelChange)="rangerChanging($event)"
            [(ngModel)]="rangerFilter" (ngModelChange)="rangerChanged($event)" #ranger maxlength="255"
            placeholder="Ranger" [matAutocomplete]="rangerAutocomplete">
          <mat-autocomplete id="rangerAutocomplete" #rangerAutocomplete [displayWith]="rangerDisplay">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let ranger of rangerSelectionListObs | async" [value]="ranger">
              {{rangerDisplay(ranger)}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </span>
    </div>
    <div class="crud-editor-warning" *ngIf="eventType == 'Stocktake' && !allFiltersPopulated()">You must select a Business Unit and Cost Centre to perform a stocktake</div>
    <div class="crud-editor-warning" *ngIf="eventType == 'Addition' && !allFiltersPopulated()">You must select a Business Unit and Cost Centre to add stock</div>
    <div class="crud-editor-warning" *ngIf="eventType == 'Issue' && !allFiltersPopulated()">You must select a Business Unit, Cost Centre, and Ranger to issue stock</div>
    <div class="crud-editor-warning" *ngIf="eventType == 'Return' && !allFiltersPopulated()">You must select a Business Unit, Cost Centre, and Ranger to return stock</div>
    <div *ngIf="allAmmunitionTypesAdded()">All ammunition stocks have been added</div>
    <div class="crud-rows-table-section">
      <div class="crud-rows-table-wrapper mat-table-wrapper">
        <mat-table formArrayName="formRows" #table [dataSource]="sortDataSource" matSort class="crud-rows-table"
                         [matSortActive]="defaultSort" [matSortDirection]="defaultSortDirection" matSortDisableClear 
                         cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal" [trackBy]="ammunitionStockEventTrackBy"
                         (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="ammunitionStockEventId">
            <mat-header-cell [crud-column-header]="columns.column('ammunitionStockEventId')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AmmunitionStockEvent.ammunitionStockEventId">
                Ammunition Stock Event Id 
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <input matInput formControlName="ammunitionStockEventId" id="ammunitionStockEventId.{{index}}"              
              (ngModelChange)="ammunitionStockEventIdRowChanging($event, element, index)" [(ngModel)]="element.ammunitionStockEventId"              
              (ngModelChange)="ammunitionStockEventIdRowChanged($event, element, index)" #ammunitionStockEventId              
              type="number" placeholder="Ammunition Stock Event Id">
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="ammunitionStock">
            <mat-header-cell [crud-column-header]="columns.column('ammunitionStock')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.AmmunitionStockEvent.ammunitionStock">
                Ammunition Stock 
            </mat-header-cell>
            <mat-cell class="search-column-small" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
              <mat-select formControlName="ammunitionStock" id="ammunitionStock.{{index}}"              
                  (ngModelChange)="ammunitionStockRowChanging($event, element, index)" [(ngModel)]="element.ammunitionStock"              
                  (ngModelChange)="ammunitionStockRowChanged($event, element, index)" #ammunitionStock              
                  placeholder="Ammunition Stock" [compareWith]="ammunitionStockCompare">
                <mat-option>Any</mat-option>
                <mat-option *ngFor="let ammunitionStock of ammunitionStockSelectionListFiltered(element)" [value]="ammunitionStock">
                  {{ammunitionStockDisplay(ammunitionStock)}}
                </mat-option>
              </mat-select>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="currentStockAmount">
            <mat-header-cell [crud-column-header]="columns.column('currentStockAmount')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-tiny" i18n="@@type.AmmunitionStockEvent.currentStockAmount">
                Current Stock Amount
            </mat-header-cell>
            <mat-cell class="search-column-tiny text-cell" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
              <span *ngIf="element.ammunitionStock == null">No Stock Selected</span>
              <span *ngIf="element.ammunitionStock != null && !element.ammunitionStock.hasStocktake" class="crud-editor-warning">No Stocktake</span>
              <span *ngIf="element.ammunitionStock != null && element.ammunitionStock.hasStocktake">{{element.ammunitionStock?.currentStockAmount}}</span>
            </mat-cell>
          </ng-container> 

          <ng-container matColumnDef="ranger">
            <mat-header-cell [crud-column-header]="columns.column('ranger')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AmmunitionStockEvent.ranger">
                Ranger 
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <mat-select formControlName="ranger" id="ranger.{{index}}"              
              (ngModelChange)="rangerRowChanging($event, element, index)" [(ngModel)]="element.ranger"              
              (ngModelChange)="rangerRowChanged($event, element, index)" #ranger              
              placeholder="Ranger" [compareWith]="rangerCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let ranger of rangerSelectionList" [value]="ranger">
              {{rangerDisplay(ranger)}}
            </mat-option>
          </mat-select>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="ammunitionStockEventType">
            <mat-header-cell [crud-column-header]="columns.column('ammunitionStockEventType')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AmmunitionStockEvent.ammunitionStockEventType">
                Ammunition Stock Event Type 
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <input matInput formControlName="ammunitionStockEventType" id="ammunitionStockEventType.{{index}}"              
              (ngModelChange)="ammunitionStockEventTypeRowChanging($event, element, index)" [(ngModel)]="element.ammunitionStockEventType"              
              (ngModelChange)="ammunitionStockEventTypeRowChanged($event, element, index)" #ammunitionStockEventType              
              placeholder="Ammunition Stock Event Type">
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="comments">
            <mat-header-cell [crud-column-header]="columns.column('comments')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-medium" i18n="@@type.AmmunitionStockEvent.comments">
                Comments 
            </mat-header-cell>
            <mat-cell class="search-column-medium" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <input matInput formControlName="comments" id="comments.{{index}}"              
              (ngModelChange)="commentsRowChanging($event, element, index)" [(ngModel)]="element.comments"              
              (ngModelChange)="commentsRowChanged($event, element, index)" #comments              
              maxlength="255" placeholder="Comments">
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="eventDate">
            <mat-header-cell [crud-column-header]="columns.column('eventDate')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmallx1">
                {{eventDateLabel}}
            </mat-header-cell>
            <mat-cell class="search-column-verysmallx1" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
              <input matInput formControlName="eventDate" id="eventDate.{{index}}" type="datetime"          
                (ngModelChange)="eventDateRowChanging($event, element, index)" [(ngModel)]="element.eventDate"              
                (ngModelChange)="eventDateRowChanged($event, element, index)" #eventDate [max]="today"             
                [matDatetimepicker]="eventDateDatePicker" placeholder="Event Date">
              <mat-datetimepicker-toggle matSuffix [for]="eventDateDatePicker"></mat-datetimepicker-toggle>
              <mat-datetimepicker #eventDateDatePicker type="datetime" color="primary"></mat-datetimepicker>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="createdBy">
            <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AmmunitionStockEvent.createdBy">
                Created By 
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <input matInput formControlName="createdBy" id="createdBy.{{index}}"              
              (ngModelChange)="createdByRowChanging($event, element, index)" [(ngModel)]="element.createdBy"              
              (ngModelChange)="createdByRowChanged($event, element, index)" #createdBy              
              maxlength="255" placeholder="Created By">
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="createdDate">
            <mat-header-cell [crud-column-header]="columns.column('createdDate')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-verysmall" i18n="@@type.AmmunitionStockEvent.createdDate">
                Created Date 
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <input matInput formControlName="createdDate" id="createdDate.{{index}}"              
              (ngModelChange)="createdDateRowChanging($event, element, index)" [(ngModel)]="element.createdDate"              
              (ngModelChange)="createdDateRowChanged($event, element, index)" #createdDate              
              [matDatepicker]="createdDateDatePicker" placeholder="Created Date">
          <mat-datepicker-toggle matSuffix [for]="createdDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateDatePicker color="primary"></mat-datepicker>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="quantity">
            <mat-header-cell [crud-column-header]="columns.column('quantity')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-tiny" i18n="@@type.AmmunitionStockEvent.quantity">
                Quantity 
            </mat-header-cell>
            <mat-cell class="search-column-tiny" [ngClass]="{'row-selected': rowSelected(element)}" *matCellDef="let element; let index = index" [formGroupName]="index">
          <input matInput formControlName="quantity" id="quantity.{{index}}"              
              (ngModelChange)="quantityRowChanging($event, element, index)" [(ngModel)]="element.quantity"              
              (ngModelChange)="quantityRowChanged($event, element, index)" #quantity              
              type="number" placeholder="Quantity" min="0">
            </mat-cell>
          </ng-container>  

  
          <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef class="search-column-verysmall">
              <div class="header-title" i18n="@@common.select">Select</div>
            </mat-header-cell>
            <mat-cell [ngClass]="{'row-selected': rowSelected(element)}" class="search-column-verysmall"
              *matCellDef="let element; let index = index">
              <button type="button" mat-raised-button color="accent" (click)="selectRow(element)"
                [disabled]="selectDisabled(element)" *ngIf="rowsSelectedByButton && !rowSelected(element)" 
                class="action-button">Select</button>
              <button type="button" mat-raised-button color="primary" *ngIf="rowsSelectedByButton && rowSelected(element)" 
                class="action-button">Selected</button>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>
      
          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions search-column-medium mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element; let i = index" class="search-column-actions search-column-medium mat-elevation-z9">
              <button type="button" class="action-button" [disabled]="!isCopyCommentsEnabled(element)" mat-raised-button matTooltip="Copy comments to all rows"
                color="primary" (click)="copyComments(element)"><mat-icon>comment</mat-icon></button>
              <button type="button"  class="action-button" [disabled]="!isCopyDateEnabled(element)" mat-raised-button matTooltip="Copy event date to all rows"
                color="primary" (click)="copyDate(element)"><mat-icon>calendar_month</mat-icon></button>
              <button type="button"  class="action-button" *ngIf="allowsDeleteRows()" [disabled]="!isDeleteEnabled(element)" mat-raised-button
                color="accent" (click)="deleteRow(element)">Remove</button>

            </mat-cell>
          </ng-container>
  
          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; let i = index; columns: columns.displayedColumns;" class="search-table"
            (click)="rowClicked(row)" [ngClass]="rowClass(row)"></mat-row>
  
        </mat-table>
      </div>
      <!--
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>
      -->
    </div>
  </form>
</div>